<template>
  <div class="pt-3">
    <CustomerInfoForm v-show="isNew" @goBack="goBack" @submit="submit" :input="input" :placeholders="placeholders" :addressData="addressData"
    :responseErrors="responseErrors">
    </CustomerInfoForm>
    <div ref="translation_detector" style="display:none;">{{translateDetectString}}</div>
    <template v-if="!isNew">
      <div v-if="addresses && addresses.length">
        <b-col class="m-auto" lg="7">
          <div class="checkout-card customer-info">
            <div class="bg-white rounded d-flex justify-content-between align-items-center card-heading-container">
              <p v-if="shippingState" class="mb-0 card-heading">SHIPPING INFORMATION</p>
              <p v-else class="mb-0 card-heading">BILLING INFORMATION</p>
              <template>
                <a v-if="showEdit" class="address-edit-btn" @click="save()">Save</a>
                <a v-else class="address-edit-btn" @click="selectAddress(addresses[0])">Edit</a>
              </template>
            </div>
            <div v-if="!showEdit" class="checkout-address-container">
                <p class="checkout-text">{{addresses[0].first_name}} {{addresses[0].last_name}}</p>
                <p class="checkout-text">{{addresses[0].address1}}<span v-if="addresses[0].address2">, {{addresses[0].address2}}</span></p>
                <p class="checkout-text">{{addresses[0].city}}, {{addresses[0].state}}, {{addresses[0].country}}, {{addresses[0].zip}} </p>
                <p class="checkout-text">{{phone}}</p>
                <p class="checkout-text">{{email}}</p>
            </div>
            <div v-else>
              <CustomerInfoForm ref="customerInfoForm"   @submit="submit" :placeholders="placeholders" :addressData="addressData" :responseErrors="responseErrors">
              </CustomerInfoForm>
              <div ref="translation_detector" style="display:none;">{{translateDetectString}}</div>
              <b-row class="cancel-container justify-content-center">
                <b-col class="col-pd col-6">
                  <button
                    class="btn btn-back mb-4 btn-outline-success paymemt-method-cancel"
                    @click.prevent="showEdit= !showEdit"
                  >  Cancel
                  </button>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-col>
      </div>
      <div v-else>
        <div class="centered-block">
          <div class="step-title">No addresses found</div>
        </div>
      </div>
      <b-row v-if="!showEdit" class="justify-content-center boxes bottom-space m-auto">
        <b-col xs="6" md="5" lg="4" class="life-btn-yes-no">
          <b-button block @click="goBack()" variant="outline-primary" class="btn-back btn-outline-success">Back</b-button>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import {InputType, TranslateTestString} from '../constants'
import { setPlaceholders } from '@/utils'
import CustomerInfoForm from './CustomerInfoForm'

export default {
  name: 'CustomerInfo',
  props: {
    input: Object
  },
  components: {
    CustomerInfoForm
  },
  data: function() {
    return {
      translateDetectString: TranslateTestString,
      placeholders: {
        first_name: '',
        last_name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: ''
      },
      showEdit: false,
      phone: '',
      email: '',
      addressData: {
        first_name: null,
        last_name: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        country: 'US'
      },
      selectedAddress: null,
      showList: true,
      addresses: [],
      isNew: false,
      addressFields: [
        {key: 'address1', label: 'Address'},
        {key: 'city', label: 'City', thClass: 'bv-d-sm-down-none', tdClass: 'bv-d-sm-down-none'},
        {key: 'state', label: 'State', thClass: 'bv-d-sm-down-none', tdClass: 'bv-d-sm-down-none'},
        {key: 'country', label: 'Country', thClass: 'bv-d-sm-down-none', tdClass: 'bv-d-sm-down-none'},
        {key: 'zip', label: 'zip', thClass: 'bv-d-sm-down-none', tdClass: 'bv-d-sm-down-none'},
        {key: 'edit', label: 'Action'}
      ],
      shippingState: false,
      responseErrors: {}
    }
  },
  computed: {
    ...mapState(['session', 'isIE'])
  },
  methods: {
    setAddress: function(address, prefix = '') {
      this.addressData.first_name = address[prefix + 'first_name'] || null
      this.addressData.last_name = address[prefix + 'last_name'] || null
      this.addressData.address1 = address[prefix + 'address1'] || null
      this.addressData.address2 = address[prefix + 'address2'] || null
      this.addressData.city = address[prefix + 'city'] || null
      this.addressData.state = address[prefix + 'state'] || null
      this.addressData.zip = address[prefix + 'zip'] || null
      this.addressData.country = address[prefix + 'country'] || 'US'
      this.$store.dispatch('wait_for_translation', {element: this.$refs['translation_detector']})
        .then(value => {
          setPlaceholders(this.placeholders)
        })
    },
    selectAddress: function(address) {
      this.showEdit = !this.showEdit
      this.isNew = false
      this.showList = false
      this.selectedAddress = address
      this.is_default = address.is_default
      let prefix = (this.input.type === InputType.ShippingAddress) ? 'ship_' : ''
      this.setAddress(this.session.customer || {}, prefix)
    },
    addAddress: function() {
      if (this.session && this.session.customer && this.session.customer['contact_id']) {
        this.isNew = true
        this.showList = false
        this.selectedAddress = null
        this.setAddress({})
      }
    },
    submit: function(addressData) {
      this.addressData = addressData
      let params = {}
      let prefix = (this.input.type === InputType.ShippingAddress) ? 'ship_' : ''

      params[prefix + 'first_name'] = this.addressData.first_name
      params[prefix + 'last_name'] = this.addressData.last_name
      params[prefix + 'address1'] = this.addressData.address1
      params[prefix + 'address2'] = this.addressData.address2
      params[prefix + 'city'] = this.addressData.city
      params[prefix + 'state'] = this.addressData.state
      params[prefix + 'zip'] = this.addressData.zip
      params[prefix + 'country'] = this.addressData.country
      if (this.selectedAddress && this.selectedAddress.id) {
        params['address_id'] = this.selectedAddress.id
      }

      this.$store.commit('busy')
      this.$store.dispatch('update_customer', params)
        .then(customer => {
          const addressType = (this.input.type === InputType.ShippingAddress) ? 'shipping' : 'billing'
          const messages = ['Your ' + addressType + ' address has been updated.']
          this.$emit('submit', this.input, null/* data */, messages)
        })
        .catch(err => {
          if (err.response.status === 400) {
            this.$store.commit('error', err)
            this.responseErrors = JSON.parse(JSON.stringify(err.response.data))
          } else {
            this.$store.commit('critical_error', err)
          }
        })
    },
    goBack: function() {
      if (this.selectedAddress || this.isNew) {
        this.selectedAddress = null
        this.isNew = false
        this.showList = true
      } else {
        this.$emit('back')
      }
    },
    save: function() {
      this.$refs.customerInfoForm.submit()
    }
  },
  created() {
    this.shippingState = this.input && this.input.type === InputType.ShippingAddress
    this.$store.commit('busy')
    this.$store.dispatch('get_addresses')
      .then(addresses => {
        this.phone = this.session.customer.phone
        this.email = this.session.customer.email
        this.addresses = []
        if (!this.addresses.length) {
          let prefix = (this.input.type === InputType.ShippingAddress) ? 'ship_' : ''
          this.addresses.push({
            first_name: this.session.customer[prefix + 'first_name'],
            last_name: this.session.customer[prefix + 'last_name'],
            address1: this.session.customer[prefix + 'address1'],
            address2: this.session.customer[prefix + 'address2'],
            city: this.session.customer[prefix + 'city'],
            state: this.session.customer[prefix + 'state'],
            zip: this.session.customer[prefix + 'zip'],
            country: this.session.customer[prefix + 'country']
          })
        }
        this.$store.commit('ready')
      })
      .catch(err => {
        this.$store.commit('critical_error', err)
      })
  },
  mounted() {
    this.$store.dispatch('wait_for_translation', {element: this.$refs['translation_detector']})
      .then(value => {
        setPlaceholders(this.placeholders)
      })
  }
}
</script>

<style scoped>

</style>
